import { render } from "./CustomerInfo.vue?vue&type=template&id=49faa1b0"
import script from "./CustomerInfo.vue?vue&type=script&lang=js"
export * from "./CustomerInfo.vue?vue&type=script&lang=js"

import "./CustomerInfo.vue?vue&type=style&index=0&id=49faa1b0&lang=css"

import exportComponent from "D:\\VueJs project\\product\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__